export class DEBIT_ADJUSTMENT_REASON {
    static readonly InsuranceOverpayment:   string = '00000533-1000-0000-0000-000000000001'
    static readonly InsurancePayment:       string = '00000533-1000-0000-0000-000000000002'
    static readonly Mistake:       string = '00000533-1000-0000-0000-000000000003'
    static readonly PatientRefund:       string = '00000533-1000-0000-0000-000000000004'
    static readonly PostingError:       string = '00000533-1000-0000-0000-000000000005'
    static readonly PrePayment:       string = '00000533-1000-0000-0000-000000000006'
    static readonly NSFCheckReversal:       string = '00000533-1000-0000-0000-000000000007'
    static readonly NSFFee:       string = '00000533-1000-0000-0000-000000000008'
    }